import { RenderOptionProps } from '../../../../CompoundFilter.types';
import { useCompoundFilterContext } from '../../../../hooks';

export const useRenderOptionProps = (itemIndex: number): RenderOptionProps | null => {
  const { state, dispatch } = useCompoundFilterContext();

  if (itemIndex < 0) {
    return null;
  }

  const itemId = state[itemIndex].id;

  const props: RenderOptionProps = {
    addOption: (newOption) =>
      dispatch({
        type: 'ADD_OPTION',
        payload: {
          itemIndex,
          newOption,
        },
      }),
    updateOption: (id, newOption) =>
      dispatch({
        type: 'UPDATE_OPTION',
        payload: {
          itemIndex,
          optionIndex: state[itemIndex].options.findIndex((x) => x.id === id),
          data: newOption,
        },
      }),
    removeOption: (id) =>
      dispatch({
        type: 'REMOVE_OPTION',
        payload: {
          itemIndex,
          optionIndex: state[itemIndex].options.findIndex((x) => x.id === id),
        },
      }),
    state,
    itemId,
  };

  return props;
};
